export interface ReservationServiceItem {
  id?: number;
  reservationId: number;
  serviceTemplateId?: number; // Optional: ID of ServiceTemplate if this item came from a template
  allowPriceChange?: boolean;
  serviceType: string;
  serviceName: string;
  description?: string;
  unitPrice: number;
  quantity: number;
  totalPrice: number;
  serviceLocation?: string;
  serviceProviderId?: number;
  serviceProviderName?: string;
  serviceDate?: string;
  status: 'PENDING' | 'COMPLETED' | 'CANCELLED';
  createdAt?: string;
  updatedAt?: string;
}

export interface ReservationServiceItemCreateRequest {
  serviceTemplateId?: number; // Optional: ID of ServiceTemplate if this item came from a template
  serviceType: string;
  serviceName: string;
  description?: string;
  unitPrice: number;
  quantity?: number;
  serviceLocation?: string;
  serviceProviderId?: number;
  serviceDate?: string;
  status?: 'PENDING' | 'COMPLETED' | 'CANCELLED';
}

export const SERVICE_TYPES = {
  RENTAL: 'RENTAL',
  DELIVERY: 'DELIVERY',
  PICKUP: 'PICKUP',
  CLEANING: 'CLEANING',
  FUEL_SERVICE: 'FUEL_SERVICE',
  VALET: 'VALET',
  OTHER: 'OTHER',
} as const;

export type ServiceType = typeof SERVICE_TYPES[keyof typeof SERVICE_TYPES];

